var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    transform: "translate(0.00195312)",
    fill: "white",
    fillOpacity: 0.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.3949 9C24.1473 9 17.5431 12.7563 12.7354 17.2272C7.95827 21.6572 4.76333 26.9651 3.25263 30.6092C2.91579 31.4156 2.91579 32.3138 3.25263 33.1202C4.76333 36.7643 7.95827 42.0721 12.7354 46.5022C17.5431 50.973 24.1473 54.7294 32.3949 54.7294C40.6425 54.7294 47.2467 50.973 52.0544 46.5022C56.8315 42.0619 60.0265 36.7643 61.5474 33.1202C61.8842 32.3138 61.8842 31.4156 61.5474 30.6092C60.0265 26.9651 56.8315 21.6572 52.0544 17.2272C47.2467 12.7563 40.6425 9 32.3949 9ZM17.6962 31.8647C17.6962 20.5496 29.9451 13.4777 39.7443 19.1352C44.2921 21.7609 47.0936 26.6133 47.0936 31.8647C47.0936 43.1798 34.8447 50.2517 25.0455 44.5941C20.4977 41.9685 17.6962 37.116 17.6962 31.8647ZM32.3949 25.3319C32.3949 28.9351 29.4654 31.8647 25.8621 31.8647C25.1374 31.8647 24.4433 31.7422 23.79 31.5278C23.2286 31.3441 22.5753 31.6911 22.5957 32.2832C22.6264 32.9875 22.7284 33.6918 22.9224 34.3961C24.3208 39.6223 29.7001 42.7254 34.9263 41.327C40.1525 39.9286 43.2556 34.5492 41.8572 29.323C40.7242 25.0869 36.978 22.2391 32.8134 22.0655C32.2214 22.0451 31.8743 22.6882 32.0581 23.2598C32.2724 23.9131 32.3949 24.6072 32.3949 25.3319Z",
    fill: "#008894"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.52f9a78ab2fbaf12810531d0d39a93d9.svg";
export { ForwardRef as ReactComponent };